import { useState } from "react";

import Tabs from "@/components/Tabs";
import { FeatureGate, PracticeFeatureFlags } from "@/feature-flags";
import NotFound from "@/NotFound";
import PermissionGate from "@/permission/components/PermissionGate";
import { BILLER_PERMISSION_FLAGS } from "@/permission/constants/practitioner-permissions";
import FeeTable from "@/settings/components/FeeTable";

import StatementSettings from "./StatementSettings";
import { BillingSettingsTab } from "./types/billing-settings";

/**
 * Billing settings page. Owns the route-level gates and the top-level section tabs; each
 * section (fee schedule, statement settings) manages its own data and sub-navigation.
 */
export default function BillingSettings() {
  const [activeSection, setActiveSection] = useState<BillingSettingsTab>("fees");

  return (
    <FeatureGate fallback={<NotFound />} name={PracticeFeatureFlags.Billing}>
      <PermissionGate
        allowPatient={false}
        fallback={<NotFound />}
        requiredPermissions={BILLER_PERMISSION_FLAGS}
      >
        <Tabs
          value={activeSection}
          data-testid="billing-settings-tabs"
          onChange={(value) => setActiveSection(value as BillingSettingsTab)}
        >
          <Tabs.List>
            <Tabs.Tab value="fees" data-testid="billing-settings-tab-fees">
              Fee Schedule
            </Tabs.Tab>
            <Tabs.Tab value="statement" data-testid="billing-settings-tab-statement">
              Statement Settings
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel pt="lg" keepMounted value="fees">
            <FeeTable />
          </Tabs.Panel>

          <Tabs.Panel pt="lg" keepMounted value="statement">
            <StatementSettings />
          </Tabs.Panel>
        </Tabs>
      </PermissionGate>
    </FeatureGate>
  );
}
